import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import BrandMark from './BrandMark';

const Sidebar = ({ activeView, setActiveView, isOpen, setIsOpen }) => {
  const primaryNav = [
    { id: 'mission', label: 'Mission Board', icon: 'Target' },
    { id: 'timeline', label: 'Flight Path', icon: 'Clock' },
    { id: 'assets', label: 'Asset Room', icon: 'Box' },
    { id: 'stakeholders', label: 'Stakeholder Sync', icon: 'Users' },
  ];

  const infoNav = [
    { id: 'guide', label: 'Operations Guide', icon: 'BookOpen' },
    { id: 'support', label: 'Support & FAQ', icon: 'HelpCircle' },
    { id: 'settings', label: 'System Config', icon: 'Settings' },
  ];

  const RenderSection = ({ items, title }) => (
    <div className="mb-6">
      <div className="text-[10px] font-mono text-slate-500 mb-3 px-4 uppercase tracking-widest">{title}</div>
      <div className="space-y-1 px-2">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => { setActiveView(item.id); setIsOpen(false); }}
            className={`w-full flex items-center px-4 py-2.5 rounded-lg transition-all duration-200 group ${
              activeView === item.id 
                ? 'bg-rocket-500/10 text-rocket-400 border border-rocket-500/30' 
                : 'text-slate-400 hover:bg-slate-800/40 hover:text-ice'
            }`}
          >
            <SafeIcon name={item.icon} className={`text-lg mr-3 ${activeView === item.id ? 'text-rocket-500' : 'text-slate-500 group-hover:text-slate-300'}`} />
            <span className="font-medium text-sm">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-slate-950/80 z-40 md:hidden backdrop-blur-sm" onClick={() => setIsOpen(false)} />
      )}

      <motion.aside className={`fixed md:static inset-y-0 left-0 z-50 w-64 glass-panel border-r border-slate-800 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 transition-transform duration-300 ease-in-out flex flex-col`}>
        <div className="h-16 flex items-center px-6 border-b border-slate-800 mb-6 shrink-0">
          <BrandMark className="w-8 h-8 mr-3" />
          <span className="text-xl font-bold tracking-wider text-ice uppercase">Launch<span className="text-rocket-500">Layer</span></span>
        </div>

        <div className="flex-1 overflow-y-auto hide-scrollbar">
          <RenderSection items={primaryNav} title="Command Center" />
          <RenderSection items={infoNav} title="Resources" />
        </div>

        <div className="p-4 mt-auto border-t border-slate-800 bg-slate-900/20 shrink-0">
          <div className="bg-slate-900/60 rounded-lg p-3 border border-slate-800">
             <div className="flex items-center justify-between mb-2">
               <span className="text-[10px] font-mono text-slate-500">IGNITION STATUS</span>
               <span className="flex h-2 w-2 relative">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                </span>
             </div>
             <div className="text-[10px] text-rocket-400 font-mono flex items-center">
               <SafeIcon name="ShieldCheck" className="mr-1 text-[8px]" />
               SECURE CONNECTION ACTIVE
             </div>
          </div>
        </div>
      </motion.aside>
    </>
  );
};

export default Sidebar;